import firebaseApp from "../../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

export default async function getProductos_presentaciones_diario() {
    
    const InformesBD =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Produccion/Produccion_diario/Informe_diario".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      InformesBD.push(doc.data());
    });
    console.log(InformesBD);
    return InformesBD;
    

}
